import { Flex, Select, Typography } from "antd"
import { useApprovedPaymentSummariesQuery } from "../../../domain/proposals/paymentSummaryQueries"
import { ApprovedQuotedGroupAmount } from "../../../domain/proposals/paymentSummary"
import { InvoiceWorkareaGroup } from "./createInvoiceModel"
import { centsToDollarsDisplay, percentageDisplayWhole } from "../../displayFormatters"
import dayjs from "dayjs"
import { Action } from "./createInvoiceReducer"
import { PricingTypes } from "../../../common/constants"
import { calculateNewAmountsFromApprovedPayment, getApprovedPaymentOptions } from "./quotedPriceCalculatorModel"

type Props = {
  jobId: number
  workareaGroups: InvoiceWorkareaGroup[]
  dispatch: (action: Action) => void
}

const ApprovedPaymentSelect = ({ jobId, workareaGroups, dispatch }: Props) => {
  const approvedPaymentSummariesQuery = useApprovedPaymentSummariesQuery(jobId)
  const summaries = getApprovedPaymentOptions(approvedPaymentSummariesQuery.data ?? [], workareaGroups)
    .map(x => ({...x, title: '', disabled: x.isApprovedGroup}))
  if (summaries.length === 0) {
    return null
  }

  const handleSelect = (groupAmount: ApprovedQuotedGroupAmount[]) => {
    if (groupAmount.length === 0) {
      return
    }

    workareaGroups.forEach(group => {
      if (group.pricingType !== PricingTypes.QuotedPrice) {
        return
      }

      const match = groupAmount.find(x => x.workareaGroupId === group.id)
      if (match) {
        dispatch({type: 'GROUP_SELECTED', groupId: group.id, value: true})
        const newAmounts = calculateNewAmountsFromApprovedPayment(workareaGroups, match)
        newAmounts.forEach(x => {
          if (x.workareaId) {
            dispatch({ type: 'WORKAREA_AMOUNT_CHANGED', workareaId: x.workareaId, value: x.amount })
          } else {
            dispatch({ type: 'AMOUNT_CHANGED', groupId: x.groupId, value: x.amount })
          }
        })
      } else {
        dispatch({type: 'GROUP_SELECTED', groupId: group.id, value: false})
      }
    })
  }

  return <Select
    placeholder="Select payment"
    value={null}
    options={summaries}
    optionRender={(option) => {
      if (option.data.isApprovedGroup) {
        return <div>
          <Typography.Text type="secondary" style={{ fontStyle: 'italic'}}>
            &mdash; Approved {dayjs(option.data.approvedAt).format('MMM D, YYYY')} at {dayjs(option.data.approvedAt).format('hh:mm a')} &mdash;
          </Typography.Text>
        </div>
      }

      return <div>
      <div><strong>{option.data.name}</strong></div>
      <Flex
        justify="space-between"
        gap={12}
      >
        <Typography.Text type="secondary" style={{ fontSize: ".8em"}}>Quoted price amount: {centsToDollarsDisplay(option.data.quotedPriceAmount)}</Typography.Text>
        <Typography.Text type="secondary" style={{ fontSize: ".8em"}}>{percentageDisplayWhole(option.data.percentage)}</Typography.Text>
      </Flex>
    </div>}}
    onSelect={(_, option) => handleSelect(option.quotedGroups)}
    style={{ width: 200 }}
    popupMatchSelectWidth={false}
  />
}

export default ApprovedPaymentSelect

